import { _decorator } from 'cc';
import RangeSlider from '../../../Components/ValuePicker/RangeSlider';
import HSLAdjuster from '../../../Components/Shader/HSLAdjuster';
import BaseColorAdjusterView, { IBaseColorAdjusterInfo } from './BaseColorAdjusterView';

interface IHSLAdjusterInfo extends IBaseColorAdjusterInfo {
    hue: number;
    saturation: number;
    lightness: number;
}

const { ccclass, property } = _decorator;

@ccclass('HSLAdjusterView')
export default class HSLAdjusterView extends BaseColorAdjusterView<HSLAdjuster> {
    @property(RangeSlider)
    private readonly hue: RangeSlider = null;

    @property(RangeSlider)
    private readonly saturation: RangeSlider = null;

    @property(RangeSlider)
    private readonly lightness: RangeSlider = null;

    private _isSyncing: boolean = false;

    public onLoad() {
        super.onLoad();
        this.hue.on(RangeSlider.EVENT_TYPE.PROGRESS_CHANGED, this.apply, this);
        this.saturation.on(RangeSlider.EVENT_TYPE.PROGRESS_CHANGED, this.apply, this);
        this.lightness.on(RangeSlider.EVENT_TYPE.PROGRESS_CHANGED, this.apply, this);
    }

    public collectAdjustInfo(): IHSLAdjusterInfo {
        const target = this.currentTarget;
        if (!target) {
            return null;
        }
        return {
            name: 'hsl',
            hue: target.hue,
            saturation: target.saturation,
            lightness: target.lightness,
        };
    }

    protected apply() {
        const target = this.currentTarget;
        if (!target || this._isSyncing) {
            return;
        }
        target.hue = this.hue.value;
        target.saturation = this.saturation.value;
        target.lightness = this.lightness.value;
    }

    protected syncUIWithTarget() {
        const target = this.currentTarget;
        if (!target) {
            return;
        }
        this._isSyncing = true;
        this.hue.progress = (target.hue + 180) / 360; // -180 to 180
        this.saturation.progress = (target.saturation + 100) / 200; // -100 to 100
        this.lightness.progress = (target.lightness + 100) / 200; // -100 to 100
        this._isSyncing = false;
    }

    protected reset() {
        this.hue.progress = 0.5;
        this.saturation.progress = 0.5;
        this.lightness.progress = 0.5;
    }
}
